import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Switch } from 'react-router-dom' // , Miss
import registerServiceWorker from './registerServiceWorker'

// Import styles
import './css/styles.css'

// Import pages to send to routes
import App from './components/App'
import AppPage from './components/AppPage'

// Import Redux and store
// import { Provider } from 'react-redux'
// import store from './store'

// Add new routes with /components/
const Routes = () => {
   return (
      // <Provider store={store}>
      <BrowserRouter>
         <div>
            <Switch>
               <Route exact path="/" component={App} />
               <Route path="/#:anchor" component={App} />
               <Route path="/:slug" component={AppPage} />
               <Route path="/events/:slug" component={AppPage} />
               <Route component={App} />
            </Switch>
         </div>
      </BrowserRouter>
      // </Provider>
   )
}

// This renders the app in './public/index.html'
ReactDOM.render(<Routes />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js